import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAZ9TM5_k3VJOILhBQ-PV3pVh2_h68ENzE",
    authDomain: "agtv-2020.firebaseapp.com",
    databaseURL: "https://agtv-2020.firebaseio.com",
    projectId: "agtv-2020",
    storageBucket: "agtv-2020.appspot.com",
    messagingSenderId: "467277239153",
    appId: "1:467277239153:web:c1c86e37c73b94d6d05cd0",
    measurementId: "G-PWH52E3S29"
  };


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app)